import { jsx as _jsx } from "react/jsx-runtime";
import { SDKProvider } from '@tma.js/sdk-react';
// eslint-disable-next-line react/display-name
export const withTmaSdk = (component) => () => {
    return (_jsx(SDKProvider, { options: {
            acceptCustomStyles: true,
            cssVars: true,
        }, children: component() }));
};
